import { combineReducers } from 'redux';
import user from './User';
import campaign from './Campaign';
import qualification from './Qualification';
import status from './Status';
export default combineReducers({
    user: user,
    campaign: campaign,
    qualification: qualification,
    status: status
});
